import { DataFormKtp } from '../../interface/customer.interfaces';
import {
  ILeasingCompany,
  Buyer,
  GlobalCart,
  ProductOrder,
  ICarbuyersDetails,
  IStnkDetails,
  IPaymentMode,
  Shipment,
  ShippingMethod,
  ILoanRequestParams,
  SeamlessData,
  IMerchant,
  IExpeditionList,
} from '../../interface/order-placement.interface';

interface OrderPlacementState {
  buyer?: Buyer;
  products: ProductOrder[];
  slots: ProductSlot[];
  vehicleProducts: (ProductVehicleDetail & {
    productCode: string;
    uuid: string;
    isVinFromInput: boolean;
    vinError?: string;
  })[];
  branch?: GlobalCart['branch'];
  carbuyersDetails: ICarbuyersDetails;
  stnkDetails: IStnkDetails;
  merchants: IMerchant[];
  leasingCompanies: ILeasingCompany[];
  selectedLeasing: ILeasingCompany;
  paymentMode: IPaymentMode;
  cartCode: string;
  shipment?: Shipment;
  carShipmentMethod: string;
  shippingMethod: ShippingMethod;
  loanRequestParams: ILoanRequestParams;
  seamlessData?: SeamlessData;
  formKtp: DataFormKtp;
  formKtpStnk: DataFormKtp;
  astrapayBalance: number | null;
  selectedExpedition: IExpeditionList;
  noBookingServiceUuids: string[];
}

enum OrderPlacementActionKind {
  HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__',
  SET_BUYER_INFO = 'SET_BUYER_INFO',
  SET_PRODUCTS = 'SET_PRODUCTS',
  SET_BRANCH = 'SET_BRANCH',
  SET_CARBUYER_DETAILS = 'SET_CARBUYER_DETAILS',
  SET_STNK_DETAILS = 'SET_STNK_DETAILS',
  SET_MERCHANTS = 'SET_MERCHANTS',
  SET_LEASING_COMPANIES = 'SET_LEASING_COMPANIES',
  SET_SELECTED_LEASING = 'SET_SELECTED_LEASING',
  SET_PAYMENT_MODE = 'SET_PAYMENT_MODE',
  SET_SLOTS = 'SET_SLOTS',
  SET_VEHICLE_PRODUCTS = 'SET_VEHICLE_PRODUCTS',
  SET_CART_CODE = 'SET_CART_CODE',
  SET_SHIPMENT = 'SET_SHIPMENT',
  SET_CAR_SHIPMENT_METHOD = 'SET_CAR_SHIPMENT_METHOD',
  SET_SHIPPING_METHOD = 'SET_SHIPPING_METHOD',
  SET_LOAN_REQUEST_PARAMS = 'SET_LOAN_REQUEST_PARAMS',
  SET_SEAMLESS_DATA = 'SET_SEAMLESS_DATA',
  SET_FORM_KTP = 'SET_FORM_KTP',
  SET_FORM_KTP_STNK = 'SET_FORM_KTP_STNK',
  SET_ASTRAPAY_BALANCE = 'SET_ASTRAPAY_BALANCE',
  RESET_STATE = 'RESET_STATE',
  SET_SELECTED_EXPEDITION = 'SET_SELECTED_EXPEDITION',
  SET_NO_BOOKING_SERVICE_UUIDS = 'SET_NO_BOOKING_SERVICE_UUIDS',
}

interface OrderPlacementAction {
  type: OrderPlacementActionKind;
  payload: any;
  branch?: OrderPlacementState['branch'];
  products?: OrderPlacementState['products'];

  // upsert vehice
  vehiclePlate?: string;
  productCode?: string;

  // upsert slot
  slots?: OrderPlacementState['slots'];

  vehicleProducts: OrderPlacementState['vehicleProducts'];
  vehicleProduct: ProductVehicleDetail & { productCode: string; uuid: string };

  // buyerDetails
  buyer?: OrderPlacementState['buyer'];

  // carbuyersDetails
  carbuyersDetails?: OrderPlacementState['carbuyersDetails'];
  stnkDetails?: OrderPlacementState['stnkDetails'];
  merchants?: OrderPlacementState['merchants'];
  leasingCompanies?: OrderPlacementState['leasingCompanies'];
  selectedLeasing?: OrderPlacementState['selectedLeasing'];

  // paymentMode
  paymentMode?: OrderPlacementState['paymentMode'];

  cartCode?: string;
  shipment?: OrderPlacementState['shipment'];

  carShipmentMethod?: OrderPlacementState['carShipmentMethod'];

  shippingMethod: OrderPlacementState['shippingMethod'];
  loanRequestParams: OrderPlacementState['loanRequestParams'];
  seamlessData?: OrderPlacementState['seamlessData'];

  formKtp?: OrderPlacementState['formKtp'];
  formKtpStnk?: OrderPlacementState['formKtpStnk'];

  astrapayBalance?: OrderPlacementState['astrapayBalance'];

  selectedExpedition?: OrderPlacementState['selectedExpedition'];

  noBookingServiceUuids?: OrderPlacementState['noBookingServiceUuids'];
}

export interface ProductVehicleDetail {
  imageUrl: string;
  image?: {
    url?: string;
    altText?: string;
  };
  carType: string;
  vin: string;
  licensePlateNumber: string;
  mileageRange: number;
  year: number;
  modelCode: string;
  carModel: string;
  colour: string;
  dayStnk: string;
  monthStnk: string;
  yearStnk: string;
  creationTime?: Date | null;
  vehicleId?: string;
  transmission?: string;
  currentSubscriptionEndDate?: string;
  packageCodeTIntouch?: string;
  subscriptionRenewalBasicAmount?: number;
}

export interface ProductVehicleTinTouch {
  imageUrl: string;
  licensePlateNumber: string;
  modelCode: string;
  carModel: string;
  currentSubscriptionEndDate: string;
}

interface ProductSlot
  extends Pick<
    ProductOrder['dataDetails'],
    'slotDate' | 'slotTime' | 'bookingDate' | 'reserveSlotNo'
  > {
  productCode: string;
  uuid: string;
}

export {
  type OrderPlacementState,
  type OrderPlacementAction,
  OrderPlacementActionKind,
  type ProductSlot,
};
